export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC',
}
